import { render } from "./StampcodeList.vue?vue&type=template&id=09e0d866&scoped=true"
import script from "./StampcodeList.vue?vue&type=script&lang=js"
export * from "./StampcodeList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-09e0d866"

export default script